import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { showSnackbar } from '../../../api/snackbarSlice';
import { apiClient } from '../../../api/axios';

export const deleteWebhook = async ({ id }) => {
  const { data } = await apiClient.delete(`/webhook-configs/${id}`);
  return data;
};

export const useDeleteWebhookHandler = ({ onSuccess } = {}) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: deleteWebhook,

    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['webhooks'] });
      queryClient.invalidateQueries({ queryKey: ['webhookStats'] });
      queryClient.invalidateQueries({ queryKey: ['global-webhook'] });
      dispatch(
        showSnackbar({
          message: 'Webhook deleted successfully',
          severity: 'success',
        }),
      );
      onSuccess && onSuccess(variables, data);
    },

    onError: (error) => {
      if (error instanceof AxiosError) {
        dispatch(
          showSnackbar({
            message: error.response?.data?.message || 'Failed to delete webhook',
            severity: 'error',
          }),
        );
      } else {
        dispatch(
          showSnackbar({
            message: error.message || 'Something went wrong',
            severity: 'error',
          }),
        );
      }
    },
  });

  return {
    deleteWebhook: mutation.mutate,
    isDeleting: mutation.isPending,
  };
};
